import React, { forwardRef, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

import { useLaneChooserTheme } from '@/playlist/games/laneChooser/theme';

export type QProps = {
	className?: string;
	style?: React.CSSProperties;
	jumping?: boolean;
	celebratingCorrect?: boolean;
	showStatic?: boolean;
	boosting?: boolean;
};

const Character = forwardRef<HTMLDivElement, QProps>(
	({ className, style, jumping, celebratingCorrect, showStatic, boosting }, ref) => {
		const theme = useLaneChooserTheme();
		const JumpSprite = theme.images.character.jump;
		const { character: characterAnimations } = theme.animations;
		const lottieRef = useRef<LottieRefCurrentProps>(null);

		const shouldShowCelebration = Boolean(celebratingCorrect && !jumping);
		const shouldShowBoost = Boolean(boosting && !jumping && !shouldShowCelebration);
		const shouldPauseIdle = Boolean(
			showStatic && !jumping && !shouldShowCelebration && !shouldShowBoost,
		);

		useEffect(() => {
			const player = lottieRef.current;
			if (!player) return;

			player.setSpeed(shouldShowBoost ? 2 : 1);

			if (shouldPauseIdle) {
				player.stop();
			} else {
				player.play();
			}
		}, [shouldPauseIdle, shouldShowBoost]);

		return (
			<div
				ref={ref}
				className={classNames('lane-chooser__character', className)}
				style={style}
			>
				{jumping ? (
					<JumpSprite />
				) : shouldShowCelebration ? (
					<Lottie animationData={characterAnimations.correct} autoplay loop={false} />
				) : (
					<Lottie
						lottieRef={lottieRef}
						animationData={characterAnimations.default}
						autoplay
						loop
					/>
				)}
			</div>
		);
	},
);

export default Character;
